import React from 'react';
import { SystemSetting } from '../../api/admin';
import Button from '../ui/Button';

interface SystemSettingsTableProps {
  settings: SystemSetting[];
  onEditSetting: (setting: SystemSetting) => void;
}

const SystemSettingsTable: React.FC<SystemSettingsTableProps> = ({ settings, onEditSetting }) => {
  return (
    <div className="border rounded-lg overflow-hidden">
      <table className="min-w-full divide-y divide-slate-200">
        <thead className="bg-slate-50">
          <tr>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Setting</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Value</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Updated By</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Updated</th>
            <th className="px-4 py-3 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Actions</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-slate-200">
          {settings.map((setting) => {
            const isEnvVar = setting.updatedBy === 'environment-variable';
            const isAllowRegister = setting.key === 'ALLOW_REGISTER';

            return (
              <tr key={setting.key} className={isEnvVar ? 'bg-blue-50' : ''}>
                <td className="px-4 py-3 whitespace-nowrap">
                  <div className="text-sm font-medium text-slate-900">
                    {setting.key}
                    {isEnvVar && (
                      <span className="ml-2 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                        Environment Variable
                      </span>
                    )}
                  </div>
                  {isAllowRegister && <div className="text-xs text-slate-500 mt-1">Controls global user registration via /register page</div>}
                  {setting.description && !isAllowRegister && <div className="text-xs text-slate-500 mt-1">{setting.description}</div>}
                </td>
                <td className="px-4 py-3 whitespace-nowrap">
                  <span
                    className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                      isAllowRegister
                        ? setting.value
                          ? 'bg-green-100 text-green-800'
                          : 'bg-red-100 text-red-800'
                        : typeof setting.value === 'boolean'
                          ? setting.value
                            ? 'bg-green-100 text-green-800'
                            : 'bg-red-100 text-red-800'
                          : 'bg-slate-100 text-slate-800'
                    }`}
                  >
                    {typeof setting.value === 'boolean' ? (setting.value ? 'true' : 'false') : String(setting.value)}
                  </span>
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500">{setting.updatedBy}</td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500">{new Date(setting.updatedAt).toLocaleString()}</td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-slate-500">
                  <div className="flex space-x-2">
                    {!isEnvVar && (
                      <Button size="sm" variant="primary" onClick={() => onEditSetting(setting)}>
                        Edit
                      </Button>
                    )}
                    {isEnvVar && <span className="text-xs text-slate-400 italic">Read-only</span>}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SystemSettingsTable;
